import type { TypographyProps } from "@circleco/compass/components/Typography";
import { Typography as CompassTypography } from "@circleco/compass/components/Typography";

import { Typography } from "@/react/components/SettingsApp/CompassCompat/Typography";
import { useTypographyFlag } from "@/react/components/SettingsApp/CompassCompat/Typography/shared";

const valueTypes = {
  sm: Typography.LabelSm,
  md: Typography.LabelMd,
  lg: Typography.LabelLg,
};

export interface ValueProps {
  children: string;
  color?: "text-green-700" | "text-primary";
  size?: "sm" | "md" | "lg";
  weight?: "normal" | "medium" | "semibold";
}

const getVariant = (
  size: "sm" | "md" | "lg",
  weight?: "normal" | "medium" | "semibold",
): TypographyProps["variant"] => {
  if (weight === "semibold") {
    return size === "sm" ? "label-sm" : "label-md";
  }
  return size === "sm" ? "body-sm" : "body-md";
};

export const Value = ({
  children,
  color = "text-primary",
  size = "sm",
  weight = "normal",
}: ValueProps) => {
  const isTypographyFlagEnabled = useTypographyFlag();

  if (isTypographyFlagEnabled) {
    if (color === "text-green-700") {
      return (
        <span className="text-green-700">
          <CompassTypography variant={getVariant(size, weight)} color="current">
            {children}
          </CompassTypography>
        </span>
      );
    }

    return (
      <CompassTypography variant={getVariant(size, weight)} color="primary">
        {children}
      </CompassTypography>
    );
  }

  const ValueComponent = valueTypes[size];
  return (
    <ValueComponent weight={weight} color={color}>
      {children}
    </ValueComponent>
  );
};
